import styled from '@emotion/styled';
import { css } from '@emotion/core';

const Dimensions = props => css`
  height: ${props.height};
  width: ${props.width};
`;

const CircleBackground = styled.div`
  background-image: -webkit-repeating-radial-gradient(
    center center,
    ${props => props.color || '#979797'},
    ${props => props.color || '#979797'} ${props => props.dotSize || '3px'},
    transparent 1px,
    transparent 100%
  );
  background-image: -ms-repeating-radåial-gradient(
    center center,
    ${props => props.color || '#979797'},
    ${props => props.color || '#979797'} ${props => props.dotSize || '3px'},
    transparent 1px,
    transparent 100%
  );
  background-image: -moz-repeating-radial-gradient(
    center center,
    ${props => props.color || '#979797'},
    ${props => props.color || '#979797'} ${props => props.dotSize || '3px'},
    transparent 1px,
    transparent 100%
  );
  background-image: repeating-radial-gradient(
    center center,
    ${props => props.color || '#979797'},
    ${props => props.color || '#979797'} ${props => props.dotSize || '3px'},
    transparent 1px,
    transparent 100%
  );

  -webkit-background-size: 50px 50px;
  -moz-background-size: 50px 50px;
  background-size: 50px 50px;

  display: inline-block;
  ${Dimensions}
`;

export default CircleBackground;
